<!--
 * @Author: wsx
 * @Date: 2022-01-22 16:11:08
 * @LastEditTime: 2022-01-22 16:51:06
 * @LastEditors: your name
 * @Description: 卡片
-->
<template>
  <div class="HCard">
    <div class="h-card-header">
      <template v-if="slotTitle">
        <slot name="title"></slot>
      </template>
      <h-title v-if="title">{{ title }}</h-title>
    </div>
    <div class="h-card-body" :style="bodyStyle">
      <slot></slot>
      <el-empty
        class="h-card-empty"
        v-if="empty"
        :description="emptyText"
      ></el-empty>
    </div>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs, useSlots } from "vue";
export default defineComponent({
  name: "HCard",
  components: {},
  props: {
    title: {
      type: String,
    },
    empty: {
      type: Boolean,
      defalut: false,
    },
    emptyText: {
      type: String,
      defalut: "暂无数据",
    },
    bodyStyle: {
      type: String,
      defalut: "",
    },
  },
  setup(props) {
    const state = reactive({});
    const refData = toRefs(state);
    const slotTitle = !!useSlots().title;
    return { ...refData, slotTitle };
  },
});
</script>
<style  lang='scss' scoped >
.HCard {
  box-shadow: var(--el-box-shadow-light);
  border-radius: 5px;
  // border: 1px solid var(--el-border-color-light, #ebeef5);
  background-color: var(--el-color-white);
  overflow: hidden;
  color: var(--el-text-color-primary);
  transition: var(--el-transition-duration);
  @include flex-col-s-s;
  .h-card-header {
    padding: 15px 0;
    margin: 0 15px;
    // padding: 15px 15px 10px 0;
    padding-bottom: 5px;
    width: 100%;
    // background: red;
    border-bottom: 3px solid var(--el-text-color-primary);
    border-image: -webkit-linear-gradient(left, #cb8847, rgba(255, 255, 255, 0))
      20 30;
  }
  .h-card-body {
    flex: 1;
    overflow: hidden;
    padding: 5px 15px 0 15px;
    // padding-top: 5px;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    .h-card-empty {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
}
</style>